import { EntityId } from '@reduxjs/toolkit';
import { UserStorage } from 'src/entities/user';
import { IFavoritesState } from './favorites.interface';

export class FavoritesService extends UserStorage<IFavoritesState> {
  setFavorites(favorites: EntityId[]) {
    this.setUserStorage({ favorites });
  }

  getFavorites(): EntityId[] {
    return this.storage.getItem()?.favorites || [];
  }

  deleteFavorites() {
    this.setUserStorage({ favorites: [] });
  }
}
